import { useSortable} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
type SortableCategoryItemProps = {
    cat: any;
    openModalEditCategory: (cat: any) => void;
    deleteCategory: (id: number) => void;
    toggleActiveCategory: (cat: any) => void;
    openItemsCategory: (id: number) => void;
};

const SortableCategoryItem: React.FC<SortableCategoryItemProps> = ({
    cat,
    openModalEditCategory,
    deleteCategory,
    toggleActiveCategory,
    openItemsCategory
}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: cat.id });

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        paddingLeft:3,
        overflow:'auto',
        width:'100%',
        background: (cat.isSeparator) ? '#fcf8e3' : (cat.isHighlight) ? '#061e06' : '#d1e7dd',
        display:'flex',
        flexDirection:'row'
    };

    return (
        <>
        {
            (cat.isSeparator !== true) ?
            <>
                <div
                    ref={setNodeRef}
                    style={style}
                    className="alert alert-success"
                >
                    <span
                        {...attributes}
                        {...listeners}
                        style={{
                            cursor: "grab",
                            marginRight: 10,
                            fontSize: 36,
                            float:'left'
                        }}
                    >
                        <i className="mdi mdi-drag"></i>
                    </span>

                    <span
                        style={{ float: 'left',  marginRight: 10, cursor: 'pointer' }}
                        onClick={() => openModalEditCategory(cat)}
                    >
                        <i
                            className="mdi mdi-pencil-box"
                            style={{
                                color: (cat.isHighlight) ? '#24a524' : '#061e06',
                                fontSize: 20
                            }}
                        />
                    </span>

                    <p
                        style={{flex: 1, marginBottom: 0, cursor: 'pointer', color: (cat.isHighlight) ? '#fbfcfb' : '#061e06', }}
                        onClick={() => openItemsCategory(cat.id)}
                    >
                        {cat.title}

                        <span style={{ display: 'block', color: '#8f8c8c' }}>
                            {cat.subTitle}
                        </span>

                        <span style={{ display: 'block', color: '#ffffff' }}>
                            SubCategorias: {cat.subCategories?.length ?? 0}, Item: {
                                cat.subCategories?.reduce((total: number, sub: any) => {
                                    return total + (sub.itemLinks?.length || 0);
                                }, 0) ?? 0
                            }
                        </span>
                    </p>
                    
                    <span style={{  marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <span
                            style={{ display: 'block', cursor: 'pointer' }}
                            onClick={() => deleteCategory(cat.id)}
                        >
                            <i
                                className="mdi mdi-delete-circle"
                                style={{ color: '#c52828', fontSize: 20 }}
                            />
                        </span>

                        <span
                            style={{ cursor: 'pointer', display: 'block' }}
                            onClick={() => toggleActiveCategory(cat)}
                        >
                            <i
                                className={`mdi ${cat.active ? "mdi-toggle-switch" : "mdi-toggle-switch-off"}`}
                                style={{
                                    fontSize: 26,
                                    color: cat.active ? "#28a745" : "#999"
                                }}
                            />
                        </span>
                    </span>
                </div>
            </>
            :
            <>
                <div
                    ref={setNodeRef}
                    style={style}
                    className="alert alert-warning"
                >
                    <span
                        {...attributes}
                        {...listeners}
                        style={{
                            cursor: "grab",
                            marginRight: 10,
                            fontSize: 36,
                            float:'left'
                        }}
                    >
                        <i className="mdi mdi-drag"></i>
                    </span>

                    <span
                        style={{ float: 'left',  marginRight: 10, cursor: 'pointer' }}
                        onClick={() => openModalEditCategory(cat)}
                    >
                        <i
                            className="mdi mdi-pencil-box"
                            style={{
                                color: (cat.isHighlight) ? '#24a524' : '#061e06',
                                fontSize: 20
                            }}
                        />
                    </span>

                    <p style={{flex: 1, marginBottom: 0, cursor: 'pointer', color: (cat.isHighlight) ? '#fbfcfb' : '#061e06', }}>
                        {cat.title}
                    </p>
                    
                    <span style={{  marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <span
                            style={{ display: 'block', cursor: 'pointer' }}
                            onClick={() => deleteCategory(cat.id)}
                        >
                            <i
                                className="mdi mdi-delete-circle"
                                style={{ color: '#c52828', fontSize: 20 }}
                            />
                        </span>

                        <span
                            style={{ cursor: 'pointer', display: 'block' }}
                            onClick={() => toggleActiveCategory(cat)}
                        >
                            <i
                                className={`mdi ${cat.active ? "mdi-toggle-switch" : "mdi-toggle-switch-off"}`}
                                style={{
                                    fontSize: 26,
                                    color: cat.active ? "#28a745" : "#999"
                                }}
                            />
                        </span>
                    </span>
                </div>
            </>
        }
        </>
        
    );
};

export default SortableCategoryItem;